/**
 * App Component
 * Bulletproof React pattern - App composition
 *
 * This is the root application component that composes:
 * - AppProvider (all application providers)
 * - AppRouter (routing configuration)
 */

import { AppProvider } from './provider';
import { AppRouter } from './router';

export const App = () => {
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
